<tc-setup-grid
        #setupGrid
        [readOnly]="false"
        [colDefConfig]="colDefConfig"
        [setupGridComp]="this"
        [dataSource]="this">
</tc-setup-grid>